module.exports = __webpack_public_path__ + "static/media/amb_question.ae2342a7.mp3";